import { Directive, ElementRef, HostListener, Input } from "@angular/core";

import {
  ScrollToService
} from "@lantern/app/core/utils/scroll-to";
import { ScrollOffset } from "@lantern/app/core/utils/scroll-to/constants";
import {
  EasingFunction,
  EasingFunctions
} from "@lantern/app/core/utils/scroll-to/easing-functions";

@Directive({
  selector: "[taScrollTo]",
  exportAs: "taScrollTo"
})
export class ScrollToElementDirective {
  @Input()
  taScrollTo: string | HTMLElement | ElementRef;

  @Input()
  taScrollToDuration: number;

  @Input()
  taScrollToOffset: ScrollOffset;

  @Input()
  taScrollToEasingFn: EasingFunction | keyof EasingFunctions;

  constructor(private scrollToService: ScrollToService) {}

  @HostListener("keydown.space")
  @HostListener("click")
  onInteraction(): void {
    let target: HTMLElement | undefined;
    if (typeof this.taScrollTo === "string") {
      target = document.querySelector(this.taScrollTo) as
        | HTMLElement
        | undefined;
    } else if (this.taScrollTo instanceof ElementRef) {
      target = this.taScrollTo.nativeElement;
    } else {
      target = this.taScrollTo;
    }

    if (target == null) {
      return;
    }

    this.scrollToService.scrollTo(
      target,
      this.taScrollToOffset,
      this.taScrollToDuration,
      this.taScrollToEasingFn
    );
  }
}
